import { ComposerEmptyStateIllustration } from './ComposerEmptyStateIllustration'
import styles from './Empty.module.css'

export const Empty = (): React.JSX.Element => (
  <div className={styles.wrapper}>
    <div className={styles.imageWrapper}>
      <ComposerEmptyStateIllustration />
      <p className={styles.message}>See your post&apos;s preview here</p>
    </div>
  </div>
)
